import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SendRequestModal from './components/DuskPhotographyBookingComponents/SendRequestModal';

type PhotographerBookingOnErrorLabels = {
    sendRequest: string;
    requestModalTitle: string;
    requestModalText: string;
    requestModalDate: string;
    requestModalInfo: string;
    cancelButton: string;
    errorMessageUnableToBook: string;
};

type SE360DuskPhotographerBookingOnErrorProps = {
    isSmallerScreen: boolean;
    labels: PhotographerBookingOnErrorLabels;
    orderCommandForBooking: [];
    createBooking: any;
};

const SE360DuskPhotographerBookingUnableToBook = ({
    labels,
    orderCommandForBooking,
    createBooking
}: SE360DuskPhotographerBookingOnErrorProps) => {
    const [showSendRequestModal, setShowSendRequestModal] = React.useState(false);
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                flexDirection: 'column',
                marginTop: '20%',
                height: '100%',
                width: '100%',
                flexWrap: 'wrap'
            }}
        >
            <Typography>{labels.errorMessageUnableToBook}</Typography>
            <Box
                aria-label="send-request-link"
                role={'button'}
                sx={{
                    fontSize: '15px',
                    fontWeight: '500',
                    color: '#4F7C6D',
                    fontFamily: "'Roboto'",
                    '&:hover': {
                        textDecoration: 'underline',
                        cursor: 'pointer'
                    },
                    padding: '20px 0 0 0',
                    margin: 0
                }}
                onClick={(e) => {
                    setShowSendRequestModal(true);
                }}
            >
                {labels.sendRequest}
            </Box>
            <SendRequestModal
                labels={labels}
                show={showSendRequestModal}
                onClose={() => {
                    setShowSendRequestModal(false);
                }}
                orderCommandForBooking={orderCommandForBooking}
                createBookingRequest={createBooking}
            />
        </Box>
    );
};

export default SE360DuskPhotographerBookingUnableToBook;
